export const formatYesNo = (value) => {
  try {
    if (value) {
      return 'YES'
    } else {
      return 'NO'
    }
  } catch (err) {
    //
  }
  return ''
}

export const formatBoolean = (value) => {
  try {
    return value === 'YES'
  } catch (err) {
    //
  }
  return ''
}
